csui.require.config({
  bundles: {
'nuc/bundles/nuc-libraries': [
'nuc/lib/backbone',
'nuc/lib/handlebars.helpers.xif',
'nuc/lib/jquery',
'nuc/lib/jquery.binary.ajax',
'nuc/lib/jquery.mockjax',
'nuc/lib/jquery.parse.param',
'nuc/lib/jquery.when.all',
'nuc/lib/jsonpath',
'nuc/lib/marionette',
'nuc/lib/marionette3',
'nuc/lib/moment',
'nuc/lib/moment-timezone',
'nuc/lib/numeral',
'nuc/lib/radio',
'nuc/utils/load-extensions/load-extensions'
],
'nuc/bundles/nuc-log4javascript': [
'nuc/lib/log4javascript',
'nuc/utils/log/console.re.appender'
],
'nuc/bundles/nuc-lessc': [
'nuc/lib/lessc',
'nuc/lib/normalize'
],
'nuc/bundles/nuc-server-adaptors': [

],
'nuc/bundles/nuc-models': [
'nuc/models/action',
'nuc/models/actions',
'nuc/models/actionitem',
'nuc/models/actionitems',
'nuc/models/addabletype',
'nuc/models/addabletypes',
'nuc/models/ancestor',
'nuc/models/ancestors',
'nuc/models/authenticated.user',
'nuc/models/authentication',
'nuc/models/clientsidecollection',
'nuc/models/column',
'nuc/models/columns',
'nuc/models/datadefinition',
'nuc/models/datadefinitions',
'nuc/models/member',
'nuc/models/member/member.model',
'nuc/models/member/membercollection',
'nuc/models/members',
'nuc/models/node/node.definition2.collection',
'nuc/models/node/node.addable.type.collection',
'nuc/models/node/node.model',
'nuc/models/node.children2/node.children2',
'nuc/models/node.columns2',
'nuc/models/nodeancestors',
'nuc/models/nodechildrencolumn',
'nuc/models/nodechildrencolumns',
'nuc/models/nodechildren',
'nuc/models/node.actions',
'nuc/models/nodes',
'nuc/models/tool.item.config/tool.item.config.collection',
'nuc/models/tool.item.mask/tool.item.mask.collection',
'nuc/models/browsable/browsable.mixin',
'nuc/models/browsable/client-side.mixin',
'nuc/models/browsable/v1.request.mixin',
'nuc/models/browsable/v1.response.mixin',
'nuc/models/browsable/v2.response.mixin',
'nuc/models/mixins/appcontainer/appcontainer.mixin',
'nuc/models/mixins/autofetchable/autofetchable.mixin',
'nuc/models/mixins/commandable/commandable.mixin',
'nuc/models/mixins/connectable/connectable.mixin',
'nuc/models/mixins/delayed.commandable/delayed.commandable.mixin',
'nuc/models/mixins/expandable/expandable.mixin',
'nuc/models/mixins/fetchable/fetchable.mixin',
'nuc/models/mixins/including.additional.resources/including.additional.resources.mixin',
'nuc/models/mixins/node.autofetchable/node.autofetchable.mixin',
'nuc/models/mixins/node.connectable/node.connectable.mixin',
'nuc/models/mixins/node.resource/node.resource.mixin',
'nuc/models/mixins/resource/resource.mixin',
'nuc/models/mixins/rules.matching/rules.matching.mixin',
'nuc/models/mixins/state.carrier/state.carrier.mixin',
'nuc/models/mixins/state.requestor/state.requestor.mixin',
'nuc/models/mixins/syncable.from.multiple.sources/syncable.from.multiple.sources.mixin',
'nuc/models/mixins/uploadable/uploadable.mixin',
'nuc/models/mixins/v2.additional.resources/v2.additional.resources.mixin',
'nuc/models/mixins/v2.commandable/v2.commandable.mixin',
'nuc/models/mixins/v2.delayed.commandable/v2.delayed.commandable.mixin',
'nuc/models/mixins/v2.expandable/v2.expandable.mixin',
'nuc/models/mixins/v2.fields/v2.fields.mixin',
'nuc/models/autofetchable',
'nuc/models/connectable',
'nuc/models/expandable',
'nuc/models/fetchable',
'nuc/models/including.additional.resources',
'nuc/models/nodeautofetchable',
'nuc/models/nodeconnectable',
'nuc/models/noderesource',
'nuc/models/resource',
'nuc/models/uploadable',
'nuc/models/utils/v1tov2',
'nuc/contexts/context',
'nuc/contexts/synchronized.context',
'nuc/contexts/context.plugin',
'nuc/contexts/fragment/context.fragment',
'nuc/contexts/mixins/clone.and.fetch.mixin',
'nuc/contexts/page/page.context',
'nuc/contexts/factories/connector',
'nuc/contexts/factories/factory',
'nuc/utils/connector',
'nuc/utils/deepClone/deepClone',
'nuc/utils/errormessage',
'nuc/utils/errors',
'nuc/utils/errors/request',
'nuc/utils/errors/response',
'nuc/utils/log',
'nuc/utils/messagehelper',
'nuc/utils/namedlocalstorage',
'nuc/utils/namedsessionstorage',
'nuc/utils/namedstorage',
'nuc/utils/page.leaving.blocker',
'nuc/utils/promoted.actionitems',
'nuc/utils/types/date',
'nuc/utils/types/localizable',
'nuc/utils/types/member',
'nuc/utils/types/number',
'nuc/utils/url',
'nuc/utils/authenticators/authenticator',
'nuc/utils/authenticators/authenticators',
'nuc/utils/authenticators/basic.authenticator',
'nuc/utils/authenticators/credentials.authenticator',
'nuc/utils/authenticators/initial.header.authenticator',
'nuc/utils/authenticators/nuc.authenticators',
'nuc/utils/authenticators/regular.header.authenticator',
'nuc/utils/authenticators/request.authenticator',
'nuc/utils/authenticators/ticket.authenticator',
'nuc/utils/authenticator',
'nuc/utils/basicauthenticator',
'nuc/utils/headerauthenticator',
'nuc/utils/requestauthenticator',
'nuc/models/authenticated.user/server.adaptor.mixin',
'nuc/models/member/server.adaptor.mixin',
'nuc/models/member/membercollection.server.adaptor',
'nuc/models/member/members.server.adaptor',
'nuc/models/node/server.adaptor.mixin',
'nuc/models/node.children/server.adaptor.mixin',
'nuc/models/node.children2/server.adaptor.mixin',
'nuc/utils/authenticators/server.adaptors/basic.mixin',
'nuc/utils/authenticators/server.adaptors/credentials.mixin',
'nuc/utils/authenticators/server.adaptors/initial.header.mixin',
'nuc/models/member/member.server.adaptor.mixin'
]
  }
});